import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
const TransactionDetail = () =>
  import("@/components/TransactionsPage/TransactionDetail/index");
import SidebarLayout from "@/components/Shared/SidebarLayout";
const Deposit = () => import("@/components/OperationsPage/Deposit/index");
const Withdrawal = () => import("@/components/OperationsPage/Withdrawal/index");
const Exchange = () => import("@/components/OperationsPage/Exchange/index");
const transitionPage = () => import("@/components/transitionPage/index");
export default {
  name: "operations-page",
  components: {
    transitionPage,
    Deposit,
    Withdrawal,
    Exchange,
    TransactionDetail,
    SidebarLayout
  },
  props: [],
  data() {
    return {
      tab: 0,
      wallet: [],
      depositData: [],
      withdrawData: [],
      exchangeData: [],
      isCurrencyLoaded: false,
      isExchangeLoaded: false,
      transferData: [],
      sidebarMenu: [
        {
          text: this.$t("sidebars.operations.deposit"),
          link: "/operations/deposit",
          icon: "$sidebarDeposit"
        },
        {
          text: this.$t("sidebars.operations.withdrawal"),
          link: "/operations/withdrawal",
          icon: "$sidebarWithdraw"
        },
        {
          text: this.$t("sidebars.operations.exchange"),
          link: "/operations/exchange",
          icon: "$sidebarExchange"
        },
        {
          text: this.$t("sidebars.operations.transfer"),
          link: "/operations/transfer",
          icon: "$sidebarTransfer"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getDepositCurrencies: types.operations.getters.GET_DEPOSIT_CURRENCIES,
      getWithdrawCurrencies: types.operations.getters.GET_WITHDRAW_CURRENCIES,
      getExchangeCurrencies: types.operations.getters.GET_EXCHANGE_CURRENCIES,
      getTransferCurrencies: types.operations.getters.GET_TRANSFER_CURRENCIES,
      userInfo: types.userInfo.getters.GET_USER_INFO
    }),
    operationTabs() {
      let data = [];
      if (!this.userInfo.is_market_platform_active) {
        this.$t("operationsPage.operationsPageDetails").find(elem => {
          if (elem.to !== "transfer") {
            data.push(elem);
          }
        });
      } else {
        data = this.$t("operationsPage.operationsPageDetails");
      }
      return data;
    }
  },
  watch: {
    getDepositCurrencies: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.depositData = newValue;
        }
      }
    },
    getWithdrawCurrencies: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.withdrawData = newValue;
        }
      }
    },
    getExchangeCurrencies: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.exchangeData = newValue;
        }
      }
    },
    getTransferCurrencies: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.transferData = newValue;
        }
      }
    },
    operationTabs: {
      immediate: true,
      handler() {
        if (this.$route.name === "withdrawal") {
          this.tab = 1;
        } else if (this.$route.name === "exchange") {
          this.tab = 2;
        } else if (this.$route.name === "transfer") {
          this.tab = 3;
        } else {
          this.tab = 0;
        }
      }
    }
  },
  mounted() {
    if (this.$route.name === "withdrawal") {
      this.tab = 1;
    } else if (this.$route.name === "exchange") {
      this.tab = 2;
    } else if (this.$route.name === "transfer") {
      this.tab = 3;
    }
    // this.getCurrenciesService();
    // this.getWalletService();
    // this.getExchangeService();
  },
  methods: {
    ...mapActions({
      currenciesDataAction: types.currencies.actions.SET_CURRENCIES,
      setWallets: types.operations.actions.SET_WALLET,
      setExchangeWallets: types.wallets.actions.SET_EXCHANGES_WALLETS,
      TdepositCurrencies: types.operations.actions.SET_DEPOSIT_CURRENCIES,
      withdrawCurrencies: types.operations.actions.SET_WITHDRAW_CURRENCIES,
      exchangeCurrencies: types.operations.actions.SET_EXCHANGE_CURRENCIES,
      transferCurrencies: types.operations.actions.SET_TRANSFER_CURRENCIES
    }),
    // getCurrenciesService() {
    //   CurrenciesService.getCurrencies().then(async response => {
    //     this.currenciesLoading = false
    //     this.currenciesDataAction(response.data.data).then(() => {
    //       this.isCurrencyLoaded = true;
    //     });
    //   });
    // },
    // getWalletService() {
    //   WalletService.getWalletV4().then(response => {
    //     this.walletLoading = false
    //
    //     this.wallet = response.data.data;
    //     this.setWallets(response.data.data);
    //     this.depositCurrencies(response.data.data);
    //     this.withdrawCurrencies(response.data.data);
    //     this.exchangeCurrencies(response.data.data);
    //     this.transferCurrencies(response.data.data);
    //   });
    // },
    // getExchangeService() {
    //   WalletService.getExchanges().then(response => {
    //     this.exchangeLoading = false
    //
    //     this.setExchangeWallets(response.data).then(() => {
    //       this.isExchangeLoaded = true;
    //     });
    //   });
    // },
    changeTabUrl(to) {
      let query = "BTC";
      // this.wallet.wallets.find((elem) => {
      //   if (elem.currency.iso === this.$route.query.from) {
      //     if (to === "deposit") {
      //       if (elem.is_deposit_active) {
      //         query = this.$route.query.from;
      //       } else {
      //         query = this.depositData[0].currency.iso;
      //       }
      //     } else if (to === "withdrawal") {
      //       if (elem.is_withdraw_active) {
      //         query = this.$route.query.from;
      //       } else {
      //         query = this.withdrawData[0].currency.iso;
      //       }
      //     } else if (to === "exchange") {
      //       if (elem.is_change_active) {
      //         query = this.$route.query.from;
      //       } else {
      //         query = this.exchangeData[0].currency.iso;
      //       }
      //     } else if (to === "transfer") {
      //       if (elem.is_transfer_to_market_place_active) {
      //         query = this.$route.query.from;
      //       } else {
      //         query = this.transferData[0].currency.iso;
      //       }
      //     }
      //   }
      // });
      if (to === "deposit" && query === "IRR") {
        this.$router.push({
          path: to,
          query: { from: query, paymentType: "online" }
        });
      } else {
        this.$router.push({ path: to, query: { from: query } });
      }
    }
  }
};
